import {
  createEffect,
  createSignal,
  //@ts-ignore
  Show,
  createSelector,
  //@ts-ignore
  For,
  onCleanup,
  onMount,
} from "solid-js";
import { View, Text, hexColor } from "@lightningtv/solid";
import { Column } from "@lightningtv/solid-ui";
import { useNavigate } from "@solidjs/router";
import axios from "axios";
import CryptoJS from "crypto-js";
import {
  deviceYear,
  isMisterOrbixShown,
  isVpnMode,
  setBuildVersion,
  setDeviceDUID,
  setDeviceID,
  setDeviceModel,
  setDeviceYear,
  setHidePlaylistInfo,
  setIsLoading,
  setIsMisterOrbixShown,
  setIsPlaying,
  setIsVpnMode,
  setManufacturer,
  setNetworkType,
  setPlayListName,
  setPlayListPassword,
  setPlayListUrl,
  setPlayListUsername,
  setScreenResolution,
  setScreenSize,
  setStorageInfo,
  setTizenVersion,
  tizenVersion,
  updateDeviceInformation,
  isUpdateModalOpen,
} from "../../state";
import QrCode from "../components/QRcode";
import packageJson from "../../package.json";
import { fontFamily, isRTL, locale, t } from "../translations/configuration";
import SetPin from "../components/SetPin";
import SetLanguage from "../components/setLanguage";
import Termsconditions from "../components/termscondition";
import { Buffer } from "buffer";
import * as Sentry from "@sentry/solid";
import { shouldBlockAccess } from "../api/providers/killSwitch";
import { checkProxyStatus, showProxyHealthMessage } from "./proxyHealth/proxyHealthCall";
import MisterOrbixVideo from "./misterOrbix/MisterOrbixVideo";
import Header from "../components/Header";
import { savePlaylistExpirationDate } from "../components/functions/saveDate";
import { IconButton } from "../components/playlistComponents/TopRightHeaders";
import { DeleteButton } from "../components/playlistComponents/DeleteButton";
import { PrivacyModeButton } from "../components/playlistComponents/PrivacyModeButton";
import QrCodeWithAxios from "../components/QRcodeaxios";
import { AddPlaylistManuallyButton } from "../components/playlistComponents/AddPlaylistManuallyButton";
import { getProxyHeaders } from "../api/proxyHeaders";

const ITEMS_PER_PAGE = 3; // Number of items to display at a time

// Module-level (not component state) so it survives LicenceScreen remounts within
// the same app session (e.g. navigating back from Home) but resets on a real app restart.
// This makes the auto-open-last-playlist check run exactly once per cold boot.
let autoPlaylistCheckDone = false;

const LicenceScreen = () => {
  let playlistColumnRef;
  let deleteColumnRef;
  let refreshRef;
  let cancelButtonRef;
  let okButtonRefrefreshRef;
  let deviceModel;
  let cancelExit;
  let okExit;
  let refrshButton;
  let searchButton;
  let privacyButtonRef;
  let deleteButtonRefs: any[] = [];
  let refreshButton;
  let playListButton;
  let toastTimeout: any;
  let killSwitchBlockModalOkRef;
  let addPlaylistManuallyRef;

  const [data, setData] = createSignal([]);
  const [deviceId, setDeviceId] = createSignal("");
  const [newToken, setNewToken] = createSignal("");
  const [currentIndex, setCurrentIndex] = createSignal(0);
  const [currentIndex2, setCurrentIndex2] = createSignal(0);
  const [response, setResponse] = createSignal(null);
  const [focusedIndex, setFocusedIndex] = createSignal(0);
  const [licenceEndDate, setLicenceEndDate] = createSignal(null);
  const [packageName, setPackageName] = createSignal("");
  const [loading, setLoading] = createSignal(true);
  const [deviceInfoLoaded, setDeviceInfoLoaded] = createSignal(false);
  const [isDialogOpen, setIsDialogOpen] = createSignal<boolean>(false);
  const [isDialogOpenExit, setIsDialogOpenExit] = createSignal<boolean>(false);
  const [playlist, setPlaylist] = createSignal("");
  const [currentDeleteButtonIndex, setCurrentDeleteButtonIndex] = createSignal(0);
  const [deleteJustPressed, setDeleteJustPressed] = createSignal(false);
  const [shouldPayScreenAppear, setShouldPayScreenApperar] = createSignal(false);
  const [tizenVersion1, setTizenVersion1] = createSignal("");
  const [chromeVersion, setChromiumVersion] = createSignal("");
  const [iDD, setId] = createSignal("");
  const [tokenImage, setTokenImage] = createSignal("");
  const [day, setDay] = createSignal("");
  const [dateTime, setDateTime] = createSignal("");
  const [showKillSwitchBlockModal, setShowKillSwitchBlockModal] = createSignal(false);
  const [playlistExpirationDates, setPlaylistExpirationDates] = createSignal<(string | null)[]>([]);
  const [playlistErrorInfo, setPlaylistErrorInfo] = createSignal<(string | null)[]>([]);
  const [showToast, setShowToast] = createSignal(false);
  const [toastMessage, setToastMessage] = createSignal("");
  const [pinExists, setPinExists] = createSignal(false);
  const [languageExists, setLanguageExist] = createSignal(false);
  const [acceptTerms, setAcceptTerms] = createSignal(false);

  const [storedPin, setStoredPin] = createSignal('');


  const API_URL = "https://orbixplay-applications-backend.orbixplay.com/api/auth/getmydata";

  const API_TOKEN =
    "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJiYWFzX2RldmljZV9pZCI6IjAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMCIsImJhYXNfZG9tYWluX2lkIjoiNjU0NDFiZjQ1OWRjYzYyNWI1YjY4ZGJlIiwic3ViIjoiNjkwYmQzNzg3NTIzZGU3NDE3M2RlNjI4IiwiaXNzIjoiNjg3N2JlNjg5OTRiMjQ5ODZlMWZkMjYwIiwianRpIjoiNjg3N2JlNjg5OTRiMjQ5ODZlMWZkMjYxIiwidHlwIjoiYWNjZXNzIiwidXNlcl9kYXRhIjp7Il9pZCI6IjY5MGJkMzc4NzUyM2RlNzQxNzNkZTYyYyIsIm1vbmdvX3VzZXJfaWQiOiI2OTBiZDM3ODc1MjNkZTc0MTczZGU2MjgiLCJkZXZpY2VpZCI6IjZCOkE3OjMzOjBDOjVGOkZCIiwiY3JlYXRlZF9hdCI6eyIkZGF0ZSI6eyIkbnVtYmVyTG9uZyI6IjE3NjIzODI3MTIwOTIifX0sInBsYXlsaXN0cyI6W10sImxpY2Vuc2VfZW5kX2RhdGUiOnsiJGRhdGUiOnsiJG51bWJlckxvbmciOiIyNTUxOTA1OTAwMDAwIn19LCJ2cG5fbGljZW5zZV9lbmRfZGF0ZSI6eyIkZGF0ZSI6eyIkbnVtYmVyTG9uZyI6IjE1ODIyMzE5MjAwMDAifX0sInBhY2thZ2VfbmFtZSI6IkZyZWUgVHJpYWwiLCJpZCI6IjY5MGJkMzc4NzUyM2RlNzQxNzNkZTYyYyIsInVwZGF0ZWRBdCI6eyIkZGF0ZSI6eyIkbnVtYmVyTG9uZyI6IjE3NzUyMDcwOTQyMDcifX19LCJpYXQiOjE3OTEwNTEyMDMsImV4cCI6MTc5MTA1NDgwM30.u5hD1K5MN0Jo2mwaDk70V4TTGU89PAc9xq7FEiXiwVU";

  const navigate = useNavigate();

  const parseISODate = isoDateString => {
    return isoDateString ? new Date(isoDateString) : null;
  };

  const generate12DigitId = (inputString: string) => {
    console.log(inputString);
    try {
      const hash = CryptoJS.SHA256(inputString).toString(CryptoJS.enc.Hex);
      const shortHash = hash.substring(0, 12).toUpperCase();
      return (
        shortHash.substring(0, 2) +
        ":" +
        shortHash.substring(2, 4) +
        ":" +
        shortHash.substring(4, 6) +
        ":" +
        shortHash.substring(6, 8) +
        ":" +
        shortHash.substring(8, 10) +
        ":" +
        shortHash.substring(10, 12)
      );
    } catch (error) {
      console.error("Error generating ID:", error);
      return "No ID found"; // Trajtimi i gabimit sipas nevojave të aplikacionit tuaj
    }
  };

  createEffect(() => {
    // Clear the specific item from localStorage
    localStorage.removeItem("moviesData");
    localStorage.removeItem("seriesData");
  });

  createEffect(() => {
    const videoAlreadyShown = sessionStorage.getItem('misterOrbixVideoShown');

    if (!videoAlreadyShown && languageExists() && acceptTerms() && pinExists()) {
      setTimeout(() => {
        setIsMisterOrbixShown(true);
        sessionStorage.setItem('misterOrbixVideoShown', 'true');
      }, 1000);
    }
  });

  function debugWebOSAPIs() {
    console.log('=== WebOS Debug ===');

    if (typeof webOSSystem !== 'undefined' && webOSSystem.deviceInfo) {
      // Parse the JSON string to get the actual object
      const deviceInfo = JSON.parse(webOSSystem.deviceInfo);

      console.log('Parsed deviceInfo:', deviceInfo);

      // Set ALL the state variables directly here
      setDeviceModel(deviceInfo.modelName || 'Unknown');
      setDeviceYear(extractYearFromLGModel(deviceInfo.modelName) || 0);
      setTizenVersion(deviceInfo.platformVersion || 'Unknown');
      setManufacturer('LG');

      // Set screen info
      const resolution = `${deviceInfo.screenWidth}x${deviceInfo.screenHeight}`;
      setScreenResolution(resolution);
      setScreenSize(calculateScreenSizeFromResolution(deviceInfo.screenWidth, deviceInfo.screenHeight));

      // Set other info
      setNetworkType("WiFi");
      setStorageInfo("Not available on WebOS");
      setDeviceDUID("Not available on WebOS");
      setBuildVersion(deviceInfo.platformVersionDot?.toString() || "");

      console.log('All device info set directly in debug function');
    }

    console.log('=== End Debug ===');
  }

  // Replace your getWebOSDeviceInfo() function with this corrected version:

  // Replace your getWebOSDeviceInfo() function with this corrected version:

  // Replace your getWebOSDeviceInfo() function with this version that uses the same data source:

  function getWebOSDeviceInfo() {
    const deviceInfo = {
      device_model: '',
      device_year: 0,
      manufacturer: 'LG',
      tizen_version: '', // Actually webOS version
      screensize: '',
      network_type: '',
      build_version: '',
      samsung_duid: '', // Will be empty for WebOS
      device_mac_address: '',
      webos_version: '',
      panel_type: '',
      screen_width: 0,
      screen_height: 0,
    };

    // Get User Agent info
    const userAgent = navigator.userAgent;
    const webosMatch = userAgent.match(/webOS\/([\d.]+)/);

    if (webosMatch) {
      deviceInfo.webos_version = webosMatch[1];
      deviceInfo.tizen_version = webosMatch[1]; // Use webOS version in place of Tizen
    }

    // Parse WebOS device info if available
    if (typeof webOSSystem !== 'undefined' && webOSSystem.deviceInfo) {
      try {
        const sysDeviceInfo = JSON.parse(webOSSystem.deviceInfo);

        deviceInfo.device_model = sysDeviceInfo.modelName || '';
        deviceInfo.device_year = extractYearFromLGModel(sysDeviceInfo.modelName) || 0;
        deviceInfo.tizen_version = sysDeviceInfo.platformVersion || '';
        deviceInfo.panel_type = sysDeviceInfo.panelType || '';
        deviceInfo.screen_width = sysDeviceInfo.screenWidth || 0;
        deviceInfo.screen_height = sysDeviceInfo.screenHeight || 0;
        deviceInfo.screensize = `${sysDeviceInfo.screenWidth || 0}x${sysDeviceInfo.screenHeight || 0}`;
        deviceInfo.build_version = sysDeviceInfo.platformVersionDot?.toString() || '';

      } catch (error) {
        console.error('Failed to parse webOSSystem.deviceInfo:', error);
      }
    }

    return deviceInfo;
  }

  // Helper function to extract year from LG model names
  function extractYearFromLGModel(modelName) {
    if (!modelName) return 0;

    console.log('Extracting year from model:', modelName);

    // LG WebOS TV model patterns:
    // OLED55B36LA -> B3 series = 2023
    // OLED55C26LA -> C2 series = 2022  
    // 55UP8100PUA -> UP81 series = 2021

    // Try to match OLED pattern first: OLED[size][series][year]
    const oledMatch = modelName.match(/OLED\d+([A-Z])(\d)/i);
    if (oledMatch) {
      const seriesLetter = oledMatch[1].toUpperCase();
      const yearDigit = parseInt(oledMatch[2]);

      // For 2020-2029, the pattern is usually:
      // X0 = 2020, X1 = 2021, X2 = 2022, X3 = 2023, etc.
      const estimatedYear = 2020 + yearDigit;
      console.log(`OLED model detected: ${seriesLetter}${yearDigit} -> ${estimatedYear}`);
      return estimatedYear;
    }

    // Try LCD/LED pattern: [size][series][year]
    const lcdMatch = modelName.match(/(\d+)([A-Z]+)(\d+)/i);
    if (lcdMatch) {
      const series = lcdMatch[2];
      const modelNum = lcdMatch[3];

      // Basic heuristic - first digit often indicates year
      const firstDigit = parseInt(modelNum.toString().charAt(0));
      if (firstDigit >= 0 && firstDigit <= 9) {
        const estimatedYear = 2020 + firstDigit;
        console.log(`LCD model detected: ${series}${modelNum} -> ${estimatedYear}`);
        return estimatedYear;
      }
    }

    // Fallback: look for any 4-digit year in the model name
    const yearMatch = modelName.match(/20(\d{2})/);
    if (yearMatch) {
      const year = parseInt('20' + yearMatch[1]);
      console.log(`Year found in model name: ${year}`);
      return year;
    }

    console.log('Could not extract year from model name');
    return 0;
  }

  function updateWebOSStateVariables() {
    if (typeof webOSSystem !== 'undefined' && webOSSystem.deviceInfo) {
      // Parse the JSON string
      const deviceInfo = JSON.parse(webOSSystem.deviceInfo);
      // Set the existing state variables
      setDeviceModel(deviceInfo.modelName || 'Unknown WebOS Device');
      setDeviceYear(extractYearFromLGModel(deviceInfo.modelName) || 0);
      setTizenVersion(deviceInfo.platformVersion || 'Unknown');
      setManufacturer('LG'); // WebOS devices are LG

      // Set screen info using your existing states
      const resolution = `${deviceInfo.screenWidth}x${deviceInfo.screenHeight}`;
      setScreenResolution(resolution);
      setScreenSize(calculateScreenSizeFromResolution(deviceInfo.screenWidth, deviceInfo.screenHeight));

      // Set network and storage info (WebOS has limited access to these)
      setNetworkType("WiFi"); // Default assumption for WebOS TVs
      setStorageInfo("Not available on WebOS"); // WebOS doesn't expose storage info easily
      setBuildVersion(deviceInfo.platformVersionDot?.toString() || "");

      // Store in localStorage using your existing structure
      const deviceInfoForStorage = {
        model: deviceInfo.modelName,
        manufacturer: 'LG',
        year: extractYearFromLGModel(deviceInfo.modelName),
        tizenVersion: deviceInfo.platformVersion, // Note: this is actually webOS version
        webosVersion: deviceInfo.platformVersion,
        panelType: deviceInfo.panelType,
        screenSize: resolution,
        generation: determineWebOSGeneration(deviceInfo.platformVersionMajor),
        lastUpdated: new Date().toISOString(),
      };

      localStorage.setItem('deviceInfo', JSON.stringify(deviceInfoForStorage));
      return deviceInfoForStorage;
    }
    return null;
  }

  // Helper function to estimate screen size from resolution (for WebOS)
  function calculateScreenSizeFromResolution(width, height) {
    // This is an estimation - WebOS doesn't provide physical screen size
    if (width >= 3840) return "55-75 inches (4K)";
    if (width >= 1920) return "32-65 inches (FHD)";
    if (width >= 1280) return "24-43 inches (HD)";
    return "Unknown size";
  }

  // Helper function for WebOS generation
  function determineWebOSGeneration(majorVersion) {
    if (majorVersion >= 13) return 'Modern WebOS';
    if (majorVersion >= 6) return 'Standard WebOS';
    if (majorVersion >= 4) return 'Legacy WebOS';
    return 'Unknown WebOS';
  }

  // Enhanced version of your existing function
  function enhancedGetDeviceDetails() {
    return getWebOSDeviceInfo(); // Use WebOS function
  }

  function getWebOSDeviceId() {
    return new Promise((resolve, reject) => {
      // Use the commented WebOS service call from your code
      webOS.service.request("luna://com.webos.service.sm", {
        method: "deviceid/getIDs",
        parameters: {
          idType: ["LGUDID"],
        },
        onSuccess: function (inResponse) {
          const deviceId = inResponse.idList[0].idValue;
          const id = generate12DigitId(deviceId);

          console.log("WebOS Device ID retrieved:", deviceId);
          console.log("Generated ID:", id);

          resolve({
            originalId: deviceId,
            formattedId: id
          });
        },
        onFailure: function (inError) {
          console.log("Failed to get WebOS device ID");
          console.log("[" + inError.errorCode + "]: " + inError.errorText);
          reject(inError);
        },
      });
    });
  }

  function getWebOSDeviceDetails() {
    const deviceDetails = {};

    // Extract WebOS version from User Agent
    const userAgent = navigator.userAgent;
    console.log("User-Agent:", userAgent);

    // Extract WebOS version
    const webosMatch = userAgent.match(/webOS\/([\d.]+)/);
    const webosVersionFromUA = webosMatch ? webosMatch[1] : "Unknown";

    // Extract Chrome version
    const chromeMatch = userAgent.match(/Chrome\/([\d.]+)/);
    const chromeVersionFromUA = chromeMatch ? chromeMatch[1] : "Unknown";

    // Set these immediately
    setTizenVersion1(webosVersionFromUA); // You might want to rename this to setWebOSVersion
    setChromiumVersion(chromeVersionFromUA);

    // Log User Agent to Sentry
    Sentry.addBreadcrumb({
      message: 'User Agent captured and versions extracted',
      category: 'device',
      data: {
        userAgent: userAgent,
        webosVersion: webosVersionFromUA,
        chromeVersion: chromeVersionFromUA
      },
      level: 'info'
    });

    // Add other static values
    deviceDetails.app_name = "OrbixPlay";
    deviceDetails.os = "WebOS";
    deviceDetails.manufacturer = "LG";

    return deviceDetails;
  }

  createEffect(() => {
    const fetchData = async () => {
      let deviceId = null;

      debugWebOSAPIs();

      try {
        // Device ID retrieval...
        const deviceResult = await getWebOSDeviceId();
        deviceId = deviceResult.originalId;
        setId(deviceResult.formattedId);

      } catch (deviceError) {
        console.error('WebOS Device ID retrieval failed:', deviceError);
        // Error handling...
      }

      // Continue with API call
      try {
        const formattedDeviceId = deviceId ? generate12DigitId(deviceId) : 'FALLBACK_ID_' + Date.now();

        // Call device info collection - but with better timing
        const deviceInfo = getWebOSDeviceInfo();
        console.log('Initial WebOS device info collected:', deviceInfo);

        // CRITICAL: Use multiple attempts to ensure WebOS data is loaded
        const attemptDeviceInfoUpdate = (attempt = 1) => {
          console.log(`🔄 Attempt ${attempt} to update device info...`);

          let webOSModelName: string | undefined;
          //@ts-ignore
          if (typeof webOSSystem !== 'undefined' && webOSSystem.deviceInfo) {
            //@ts-ignore
            try { webOSModelName = JSON.parse(webOSSystem.deviceInfo).modelName; } catch { }
          }

          if (webOSModelName) {
            console.log('✅ WebOS data is ready, updating state variables...');

            // Update state variables
            const storedDeviceInfo = updateWebOSStateVariables();

            console.log('storedDevice', storedDeviceInfo);


            // Also call existing function if it exists
            if (typeof updateDeviceInformation === 'function') {
              // Get fresh data for the legacy function
              const freshDeviceInfo = getWebOSDeviceInfo();
              updateDeviceInformation(freshDeviceInfo);
            }

            console.log('✅ All device state updated successfully');

          } else if (attempt < 5) {
            console.log(`⏳ WebOS data not ready yet, retrying in ${attempt * 500}ms...`);
            setTimeout(() => attemptDeviceInfoUpdate(attempt + 1), attempt * 500);
          } else {
            console.warn('❌ Failed to get WebOS data after 5 attempts');
          }
        };

        // Start the update attempts
        setTimeout(() => attemptDeviceInfoUpdate(), 100);

        // Continue with API call
        const response = await axios.post("https://orbixplay-applications-backend.orbixplay.com/api/auth/login", {
          deviceid: formattedDeviceId,
          ...getWebOSDeviceDetails(),
          ...deviceInfo, // This might have empty data initially, but that's OK
          appid: "2",
        });

        setResponse(response.data);

      } catch (apiError) {
        console.error("Failed to fetch:", apiError);
        // Error handling...
      }
    };

    fetchData();
  }, []);

  createEffect(() => {
    const tedhenat = response();

    if (tedhenat) {
      //@ts-ignore
      setNewToken(tedhenat.access_token);
    }
  });

  const fetchPlaylistData = async () => {
    const tedhenat: any = response();
    setLoading(true);
    if (tedhenat) {
      setTokenImage(tedhenat.access_token);
      try {
        const response = await axios.post(
          API_URL,
          {}, // empty body (your Postman request has no body)
          {
            headers: {
              Authorization: `Bearer ${tedhenat?.access_token}`,
              "Content-Type": "application/json",
            },
          }
        );
        setData(response.data.playlists);
        setDeviceId(response.data.deviceid);
        setDeviceID(response.data.deviceid);
        setPackageName(response?.data?.package_name);
        localStorage.setItem("licenceData", JSON.stringify(response.data));
        localStorage.setItem("proxy_url", response.data.proxy_url);

        const licenceEndDateValue: any = parseISODate(response.data.license_end_date);
        const vpnLicenceEndDateValue: any = parseISODate(response.data.vpn_license_end_date);

        // Determine the latest end date
        const latestEndDate =
          licenceEndDateValue > vpnLicenceEndDateValue ? licenceEndDateValue : vpnLicenceEndDateValue;

        setLicenceEndDate(latestEndDate);

      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    }
  };

  createEffect(() => {
    fetchPlaylistData();
  }, [currentIndex2()]);

  const isFirst = createSelector(() => {
    return 0;
  });

  createEffect(() => {
    setIsPlaying(false);
  });

  const onDown = () => {
    // If no playlists exist, handle navigation differently
    if (data().length === 0) {
      // From refresh button, go to privacy mode
      refreshRef?.setFocus();
      return;
    }

    // Original logic for when playlists exist
    if (data().length < 4) {
      if (focusedIndex() < data().length - 1) {
        setFocusedIndex(focusedIndex() + 1);
      } else if (currentIndex() + data().length < data().length) {
        setCurrentIndex(currentIndex() + 1);
      } else {
        privacyButtonRef?.setFocus();
      }
    } else {
      if (focusedIndex() < ITEMS_PER_PAGE - 1) {
        setFocusedIndex(focusedIndex() + 1);
      } else if (currentIndex() + ITEMS_PER_PAGE < data().length) {
        setCurrentIndex(currentIndex() + 1);
      } else {
        privacyButtonRef?.setFocus();
      }
    }
  };

  const onUp = () => {
    // If no playlists exist, handle navigation differently
    if (data().length === 0) {
      // From privacy mode, go to refresh button
      refrshButton.setFocus();
      return;
    }

    // Original logic for when playlists exist
    if (focusedIndex() > 0) {
      setFocusedIndex(focusedIndex() - 1);
    } else if (currentIndex() > 0) {
      setCurrentIndex(currentIndex() - 1);
    } else {
      refrshButton.setFocus();
    }
  };

  const onRight = () => {
    const child = deleteColumnRef?.children?.[focusedIndex()];
    if (child) child.setFocus();
  };

  const onLeft = () => {
    const child = playlistColumnRef?.children?.[focusedIndex()];
    if (child) child.setFocus();
  };

  onMount(() => {
    const now = new Date();
    const currentLocale = locale();

    // Define day names for each language
    const dayNamesByLocale = {
      en: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
      sa: ["الأحد", "الاثنين", "الثلاثاء", "الأربعاء", "الخميس", "الجمعة", "السبت"],
      it: ["Domenica", "Lunedì", "Martedì", "Mercoledì", "Giovedì", "Venerdì", "Sabato"],
      de: ["Sonntag", "Montag", "Dienstag", "Mittwoch", "Donnerstag", "Freitag", "Samstag"],
      es: ["Domingo", "Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado"],
      fr: ["Dimanche", "Lunedi", "Mardi", "Mercredi", "Jeudi", "Vendredi", "Samedi"]
    };

    const dayNames = dayNamesByLocale[currentLocale] || dayNamesByLocale.en;
    const dayName = dayNames[now.getDay()];

    // Manual formatting with western numerals for all languages
    const day = String(now.getDate()).padStart(2, '0');
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const year = now.getFullYear();
    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');

    const formattedDate = `${day}/${month}/${year}`;
    const formattedTime = `${hours}:${minutes}`;

    setDay(dayName);
    setDateTime(`${formattedDate} | ${formattedTime}`);

    const cached = localStorage.getItem("licenceData");
    if (cached) {
      try {
        const parsed = JSON.parse(cached);
        if (parsed.deviceid) setDeviceId(parsed.deviceid);
      } catch (_) { }
    }

    // Try to get the WebOS device ID immediately for QR code
    // getWebOSDeviceId() is already defined above and uses the correct LG API
    getWebOSDeviceId()
      .then((result: any) => {
        setId(result.formattedId);
      })
      .catch((err) => {
        console.warn("Could not get WebOS device ID on mount:", err);
        // Fall back to a generated ID from cached deviceid if available
        const cached = localStorage.getItem("licenceData");
        if (cached) {
          try {
            const parsed = JSON.parse(cached);
            if (parsed.deviceid) setId(parsed.deviceid);
          } catch (_) { }
        }
      })
      .finally(() => {
        setDeviceInfoLoaded(true);
      });

    // Collect device info for Settings > Device Information
    //@ts-ignore
    if (typeof webOSSystem !== 'undefined' && webOSSystem.deviceInfo) {
      // Newer LG TVs (webOS 3+): webOSSystem.deviceInfo is available
      updateWebOSStateVariables();
      updateDeviceInformation(getWebOSDeviceInfo());
    } else {
      // Older LG TVs (webOS 1.x / 2.x): fall back to webOS.deviceInfo() callback
      try {
        //@ts-ignore
        webOS.deviceInfo(function (info: any) {
          setManufacturer('LG');
          setDeviceModel(info.modelName || '');
          setDeviceYear(extractYearFromLGModel(info.modelName) || 0);
          setTizenVersion(info.platformVersion || '');
          setScreenResolution(`${info.screenWidth || 0}x${info.screenHeight || 0}`);
          setScreenSize(calculateScreenSizeFromResolution(info.screenWidth || 0, info.screenHeight || 0));
          setBuildVersion(info.platformVersionDot?.toString() || '');
        });
      } catch (e) {
        console.warn('Could not get LG device info via webOS.deviceInfo():', e);
      }
    }
  });

  const handleDelete = playList => {
    const newData = data().filter((_, i) => i !== currentDeleteButtonIndex());
    setPlaylist(playList);
    setData(newData);
    setCurrentIndex(0);
    setFocusedIndex(0);
    updatePlaylistsOnDb(playList);
  };

  const setDeleteButtonIndex = (index, playList) => {
    setPlaylist(playList);
    setCurrentDeleteButtonIndex(index);
    setIsDialogOpen(true);
    cancelButtonRef?.setFocus();
  };

  onCleanup(() => {
    clearTimeout(toastTimeout);
  });

  const updatePlaylistsOnDb = async (playlist: any) => {
    const tedhenat: any = response();

    try {
      const response = await fetch(
        "https://orbixplay-applications-backend.orbixplay.com/api/auth/hideplaylist",
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${tedhenat.access_token}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            playlistName: playlist.playlistName,
          }),
        },
      );

      if (!response.ok) {
        throw new Error("Failed to update playlist");
      }

      const data = await response.json();
      fetchPlaylistData();
      return data;
    } catch (error) {
      console.error("Error updating playlist:", error);
    }
  };

  const expiredLink = "https://orbixplay.com/";

  const showToastMessage = (message: string) => {
    clearTimeout(toastTimeout);
    setToastMessage(message);
    setShowToast(true);
    toastTimeout = setTimeout(() => {
      setShowToast(false);
    }, 3000); // auto-dismiss after 3 seconds
  };

  const changeIndex = async newIndex => {
    const tedhenat: any = data();

    // KILL SWITCH CHECK FIRST
    if (shouldBlockAccess()) {
      console.log("Kill Switch is blocking access - Privacy Mode required");
      setShowKillSwitchBlockModal(true);
      setTimeout(() => { killSwitchBlockModalOkRef?.setFocus(); }, 100);
      return;
    }

    if (!tedhenat[newIndex].whitelist && isLicenceExpired()) {
      console.log("Licence has expired. Cannot change index.");
      setShouldPayScreenApperar(true);
      return;
    }

    // Block navigation if playlist status is red (expired/inactive)
    const currentStatuses = playlistStatus();
    const playlistIsActive = currentStatuses[newIndex];
    if (playlistIsActive === false) {
      console.log("Playlist is expired or inactive. Cannot navigate.");
      showToastMessage(t("playlistNotValid")); // or any string directly
      return;
    }

    const proxyHealthy = await checkProxyStatus();
    if (!proxyHealthy && isVpnMode() === true) {
      showProxyHealthMessage();
      return;
    }

    const expirationDates = playlistExpirationDates();
    const expDate = expirationDates[newIndex];
    savePlaylistExpirationDate(expDate ? expDate : null);

    try {
      setPlayListName(tedhenat[newIndex].playlistName);
      setHidePlaylistInfo(tedhenat[newIndex].hide_playlist_info);
      setPlayListPassword(tedhenat[newIndex].password);
      const rawUrl = tedhenat[newIndex].url;
      const normalizedUrl = getBaseUrl(rawUrl) || rawUrl;
      setPlayListUrl(normalizedUrl);
      localStorage.setItem("url", normalizedUrl);
      saveToStorage(tedhenat[newIndex].playlist_added_at, expDate);
      setPlayListUsername(tedhenat[newIndex].username);
      setCurrentIndex2(newIndex);
      localStorage.setItem(
        "lastOpenedPlaylist",
        JSON.stringify({
          playlistName: tedhenat[newIndex].playlistName,
          username: tedhenat[newIndex].username,
        }),
      );
      navigate("/home");
      setIsPlaying(true);
    } catch (error) {
      console.error("Fetching data failed:", error);
    }
  };
  const saveToStorage = async (createdAt: any, expDate?: any) => {
    if (expDate) {
      const expDateObj = new Date(expDate * 1000);
      const formatted = expDateObj.toLocaleDateString("en-GB");
      localStorage.setItem("@playlistExpDate", formatted);
    } else {
      localStorage.removeItem("@playlistExpDate");
    }

    if (createdAt) {
      const createdDateObj = new Date(createdAt);
      const formatted = createdDateObj.toLocaleDateString("en-GB");
      localStorage.setItem("@playlistCreatedAt", formatted);
    } else {
      localStorage.removeItem("@playlistCreatedAt");
    }
  }

  const [playlistStatus, setPlaylistStatus] = createSignal([]);
  const [asyncStatus, setAsyncStatus] = createSignal(false);
  // ── NEW: tracks whether each playlist failed to respond (true = network/request failure)
  const [playlistFailed, setPlaylistFailed] = createSignal<boolean[]>([]);

  const isExpiredTimestamp = (expDate: string | null): boolean => {
    if (!expDate) return false;
    return new Date(parseInt(expDate) * 1000) < new Date();
  };

  function getBaseUrl(url) {
    try {
      const parsedUrl = new URL(url);
      return `${parsedUrl.protocol}//${parsedUrl.host}`;
    } catch (error) {
      console.error("Invalid URL:", error);
      return null;
    }
  }

  const safeFocusManager = {
    setFocus: (ref: any, fallbackRef?: any, description?: string) => {
      try {
        if (ref && typeof ref.setFocus === 'function') {
          console.log(`✅ Setting focus to ${description || 'element'}`);
          ref?.setFocus();
          return true;
        } else {
          console.warn(`⚠️ Cannot focus ${description || 'element'}: ref is null or missing setFocus method`);

          if (fallbackRef && typeof fallbackRef.setFocus === 'function') {
            console.log(`🔄 Using fallback focus for ${description || 'element'}`);
            fallbackRef?.setFocus();
            return true;
          }

          return false;
        }
      } catch (error) {
        console.error(`❌ Error setting focus to ${description || 'element'}:`, error);

        if (fallbackRef) {
          try {
            fallbackRef?.setFocus();
            return true;
          } catch (fallbackError) {
            console.error(`❌ Fallback focus also failed:`, fallbackError);
          }
        }

        return false;
      }
    },

    waitForElement: async (getRef: () => any, maxWaitMs = 2000, checkIntervalMs = 100) => {
      const startTime = Date.now();

      while (Date.now() - startTime < maxWaitMs) {
        const ref = getRef();
        if (ref && typeof ref.setFocus === 'function') {
          return ref;
        }
        await new Promise(resolve => setTimeout(resolve, checkIntervalMs));
      }

      console.warn(`⏰ Timeout waiting for element after ${maxWaitMs}ms`);
      return null;
    }
  };

  const getErrorDescription = (data: any, httpStatus?: number): string => {
    // HTTP-level errors
    if (httpStatus) {
      const httpMessages: Record<number, string> = {
        400: "Response 400: Bad request",
        401: "Response 401: Unauthorized",
        403: "Response 403: Access forbidden",
        404: "Response 404: Server not found",
        429: "Response 429: Too many requests",
        500: "Response 500: Server error",
        502: "Response 502: Bad gateway",
        503: "Response 503: Service unavailable",
        504: "Response 504: Gateway timeout",
      };
      return httpMessages[httpStatus] ?? `Response: ${httpStatus}`;
    }

    // API-level error codes (e.g. { error: "CON_SVP", status: 401 })
    if (data?.error) {
      const apiErrors: Record<string, string> = {
        CON_SVP: "VPN/Proxy blocked",
        CON_BAN: "IP banned",
        CON_MAX: "Max connections reached",
        CON_GEO: "Geo-restricted",
        CON_EXP: "Subscription expired",
        CON_DIS: "Account disabled",
        CON_INV: "Invalid credentials",
        CON_SUS: "Account suspended",
        CON_TRIAL: "Trial ended",
        CON_LIMIT: "Connection limit hit",
      };
      const desc = apiErrors[data.error];
      const statusCode = data.status ? ` (${data.status})` : "";
      return desc
        ? `${desc}${statusCode}`
        : `Bad status: ${data.status ?? data.error}`;
    }

    return "Invalid line";
  };


  const checkPlaylists = async () => {
    const tedhenat: any = data();
    if (!tedhenat) return;

    const vpnStatus = localStorage.getItem("vpn");
    const proxyUrl = localStorage.getItem("proxy_url");

    // Initialize both arrays — undefined = still loading, false = done & invalid
    setPlaylistStatus(new Array(tedhenat.length).fill(undefined));
    setPlaylistFailed(new Array(tedhenat.length).fill(false));
    setPlaylistExpirationDates(new Array(tedhenat.length).fill(null));
    setPlaylistErrorInfo(new Array(tedhenat.length).fill(null));

    const checkSinglePlaylist = async (playlist: any, index: number) => {
      const newUrl = getBaseUrl(playlist.url);
      let apiUrl = `${newUrl}/player_api.php?username=${playlist.username}&password=${playlist.password}`;

      if (vpnStatus === "on" && proxyUrl) {
        const bufferedUrl = Buffer.from(apiUrl, "utf-8").toString("base64");
        apiUrl = `${proxyUrl}${bufferedUrl}`;
      }

      const setErrorInfo = (msg: string) => {
        setPlaylistErrorInfo(prev => {
          const next = [...prev];
          next[index] = msg;
          return next;
        });
      };

      const markAsFailedLine = (errorMsg?: string) => {
        setPlaylistFailed(prev => { const next = [...prev]; next[index] = true; return next; });
        setPlaylistStatus(prev => { const next = [...(prev || [])]; next[index] = false; return next; });
        setPlaylistExpirationDates(prev => { const next = [...prev]; next[index] = null; return next; });
        if (errorMsg) setErrorInfo(errorMsg);
      };

      const markAsInvalid = (errorMsg?: string) => {
        setPlaylistFailed(prev => { const next = [...prev]; next[index] = false; return next; });
        setPlaylistStatus(prev => { const next = [...(prev || [])]; next[index] = false; return next; });
        setPlaylistExpirationDates(prev => { const next = [...prev]; next[index] = null; return next; });
        if (errorMsg) setErrorInfo(errorMsg);
      };

      try {
        const response = await axios.get(apiUrl, {
          timeout: 5000,
          headers: vpnStatus === "on" && proxyUrl ? getProxyHeaders() : undefined,
        });
        const data = response?.data;

        // Non-200 HTTP response
        if (response.status !== 200) {
          markAsFailedLine(`Response: ${response.status}`);
          return false;
        }

        // No response body or error shape
        if (!data || typeof data !== "object") {
          markAsFailedLine();
          return false;
        }

        // Error response like { error: "CON_SVP", status: 401 }
        if (data.error || data.status === 401) {
          markAsInvalid(getErrorDescription(data));
          return false;
        }

        // No user_info — treat as failed line
        if (!data.user_info) {
          markAsFailedLine();
          return false;
        }

        const userInfo = data.user_info;
        const expDate = userInfo?.exp_date;
        const status = userInfo?.status;
        const auth = userInfo?.auth;

        // auth === 0 — credentials rejected
        if (auth === 0 || auth === "0") {
          markAsInvalid(`Bad status: ${status ?? "Unauthorized"}`);
          return false;
        }

        // status not Active
        const isExpiredStatus = status && status.toLowerCase() !== "active";
        if (isExpiredStatus) {
          setPlaylistExpirationDates(prev => { const next = [...prev]; next[index] = expDate || null; return next; });
          setPlaylistFailed(prev => { const next = [...prev]; next[index] = false; return next; });
          setPlaylistStatus(prev => { const next = [...(prev || [])]; next[index] = false; return next; });
          return false;
        }

        // ✅ Valid active playlist
        setPlaylistExpirationDates(prev => { const next = [...prev]; next[index] = expDate || null; return next; });
        setPlaylistFailed(prev => { const next = [...prev]; next[index] = false; return next; });
        setPlaylistStatus(prev => { const next = [...(prev || [])]; next[index] = true; return next; });
        setErrorInfo(null);
        return true;

      } catch (error: any) {
        // Network error, timeout, DNS failure
        const httpStatus = error?.response?.status;
        const errorMsg = httpStatus
          ? getErrorDescription(error.response?.data, httpStatus)
          : "Invalid line";
        markAsFailedLine(errorMsg);
        return false;
      }
    };

    const promises = tedhenat.map((playlist: any, index: number) =>
      checkSinglePlaylist(playlist, index)
    );

    try {
      await Promise.allSettled(promises);
      setAsyncStatus(true);
    } catch (error) {
      setAsyncStatus(true);
    }
  };

  createEffect(() => {
    checkPlaylists();
  });

  // Once per app session (cold boot): if there's a playlist to resume — the one just
  // added, the last one opened, or the only playlist that exists — run it through the
  // exact same validity checks as a manual open (changeIndex) and jump straight to
  // Home if it passes. If it fails any check, or there's nothing to resume, changeIndex
  // simply won't navigate and the user is left on this screen as usual.
  //
  // Deliberately keyed off `loading()` + per-index `playlistStatus()`, not `asyncStatus`:
  // asyncStatus flips true the instant checkPlaylists() first runs against the initial
  // empty data() array (Promise.allSettled([]) resolves immediately), which is well
  // before the real playlist list has even been fetched. Consuming the one-shot flag on
  // that premature signal meant this effect never got a real chance to run again.
  // Disabled: the app must always open on the Licence screen, never auto-resume
  // straight into Home. Left in place (commented) in case auto-resume is wanted back.
  /*
  createEffect(() => {
    if (autoPlaylistCheckDone) return;
    if (loading()) return; // playlist list itself hasn't finished fetching yet

    const playlists: any = data();
    if (!playlists) return;

    if (playlists.length === 0) {
      autoPlaylistCheckDone = true; // genuinely no playlists on this account
      return;
    }

    const statuses = playlistStatus();
    const allChecked = statuses.length === playlists.length && statuses.every(s => s !== undefined);
    if (!allChecked) return; // per-playlist validity checks still in flight — don't consume the flag yet

    autoPlaylistCheckDone = true;

    let targetIndex = -1;

    if (sessionStorage.getItem("justAddedPlaylist")) {
      sessionStorage.removeItem("justAddedPlaylist");
      let newestTime = -Infinity;
      playlists.forEach((p: any, i: number) => {
        const addedTime = p.playlist_added_at ? new Date(p.playlist_added_at).getTime() : 0;
        if (addedTime > newestTime) {
          newestTime = addedTime;
          targetIndex = i;
        }
      });
    }

    if (targetIndex === -1) {
      const lastRaw = localStorage.getItem("lastOpenedPlaylist");
      if (lastRaw) {
        try {
          const last = JSON.parse(lastRaw);
          targetIndex = playlists.findIndex(
            (p: any) => p.playlistName === last.playlistName && p.username === last.username,
          );
        } catch (_) { }
      }
    }

    if (targetIndex === -1 && playlists.length === 1) {
      targetIndex = 0;
    }

    if (targetIndex !== -1) {
      changeIndex(targetIndex);
    }
  });
  */

  const isLicenceExpired = () => {
    // Check if the licence end date is not set
    if (!licenceEndDate()) {
      return true;
    }

    //@ts-ignore
    const endDate = new Date(licenceEndDate());
    // Ensure endDate is valid
    if (isNaN(endDate.getTime())) {
      console.error("Invalid licence end date format");
      return true; // Assuming invalid date means expired
    }

    // Get the current date
    const currentDate = new Date();

    // Compare the dates
    return endDate < currentDate;
  };

  const togglePrivacyMode = async () => {
    if (isVpnMode() === false) {
      const proxyHealthy = await checkProxyStatus();
      if (!proxyHealthy) {
        showProxyHealthMessage();
        return;
      } else {
        setIsVpnMode(true);
        localStorage.setItem("vpn", "on");
      }
    } else {
      setIsVpnMode(false);
      localStorage.setItem("vpn", "off");
    }
  };

  const FallbackView = () => (
    <View x={0} y={0} width={1600} height={760}>

      {/* ── LEFT SIDE ── */}
      <View x={isRTL() ? 740 : 60} y={60} width={800}>

        {/* Title */}
        <Text style={{ fontSize: 48, fontWeight: isRTL() ? "normal" : "bold", color: hexColor("#ffffff"), fontFamily: fontFamily() }}>
          {t("noLicence")}
        </Text>
        <Text y={65} style={{ fontSize: 26, color: hexColor("#8b949e"), fontFamily: fontFamily() }}>
          {t("scanLicence")}
        </Text>

        {/* HOW TO ACTIVATE */}
        <Text y={140} style={{ fontSize: 32, ffontWeight: isRTL() ? "normal" : "bold", color: hexColor("#ffffff"), fontFamily: fontFamily() }}>
          {t("instructions")}
        </Text>

        {/* Step 1 */}
        <View y={200} style={{ flexDirection: "row", alignItems: "center" }}>
          {/* Circle number */}
          <View width={50} height={50} borderRadius={25} color={hexColor("#00000000")}
            style={{ borderWidth: 2, borderColor: hexColor("#ffffff") }}>
            <Text x={16} y={12} style={{ fontSize: 22, color: hexColor("#ffffff"), fontWeight: isRTL() ? "normal" : "bold" }}>1</Text>
          </View>
          <View x={70} y={0}>
            <Text style={{ fontSize: 26, color: hexColor("#ffffff"), fontWeight: isRTL() ? "normal" : "bold", fontFamily: fontFamily() }}>
              {t("step1")}
            </Text>
            <Text y={35} style={{ fontSize: 22, color: hexColor("#FFA500FF"), fontFamily: fontFamily() }}>
              {t("locateqr")}
            </Text>
          </View>
        </View>

        {/* Step 2 */}
        <View y={310} style={{ flexDirection: "row", alignItems: "center" }}>
          <View width={50} height={50} borderRadius={25} color={hexColor("#00000000")}
            style={{ borderWidth: 2, borderColor: hexColor("#ffffff") }}>
            <Text x={16} y={12} style={{ fontSize: 22, color: hexColor("#ffffff"), fontWeight: isRTL() ? "normal" : "bold" }}>2</Text>
          </View>
          <View x={70} y={0}>
            <Text style={{ fontSize: 26, color: hexColor("#ffffff"), fontWeight: isRTL() ? "normal" : "bold", fontFamily: fontFamily() }}>
              {t("step2")}
            </Text>
            <Text y={35} style={{ fontSize: 22, color: hexColor("#8b949e"), fontFamily: fontFamily() }}>
              {t("afterScan")}
            </Text>
          </View>
        </View>

        {/* Step 3 */}
        <View y={420} style={{ flexDirection: "row", alignItems: "center" }}>
          <View width={50} height={50} borderRadius={25} color={hexColor("#00000000")}
            style={{ borderWidth: 2, borderColor: hexColor("#ffffff") }}>
            <Text x={16} y={12} style={{ fontSize: 22, color: hexColor("#ffffff"), fontWeight: isRTL() ? "normal" : "bold" }}>3</Text>
          </View>
          <View x={70} y={0}>
            <Text style={{ fontSize: 26, color: hexColor("#ffffff"), fontWeight: isRTL() ? "normal" : "bold", fontFamily: fontFamily() }}>
              {t("step3")}
            </Text>
            <Text y={35} width={100} style={{ fontSize: 22, color: hexColor("#8b949e"), fontFamily: fontFamily() }}>
              {t("onceYou")}
            </Text>
          </View>
        </View>

      </View>

      {/* ── DIVIDER ── */}
      <View x={isRTL() ? 448 : 1150} y={60} width={2} height={500} color={hexColor("#2d3748")} />

      {/* ── RIGHT SIDE — QR + MAC ── */}
      <View x={1100} y={40} width={500}>

        {/* White QR box */}
        <View x={100} y={40} width={300} height={300} borderRadius={16} color={hexColor("#ffffff")}>
          <QrCodeWithAxios deviceID={iDD()} />
        </View>

        {/* MAC Address card */}
        <View x={100} y={400} width={300} height={90} borderRadius={12} color={hexColor("#2d3748")}>
          <Text x={20} y={12} style={{ fontSize: 20, color: hexColor("#8b949e"), fontWeight: isRTL() ? "normal" : "bold", textAlign: "center" }} width={300}>
            {t("deviceId")}
          </Text>
          <Text x={20} y={40} style={{ fontSize: 26, color: hexColor("#ffffff"), fontWeight: isRTL() ? "normal" : "bold", textAlign: "center" }} width={300}>
            {deviceId()}
          </Text>
        </View>
      </View>

      {/* ── BOTTOM BUTTONS ── */}
      <View x={400} y={620} style={{ flexDirection: "row" }} gap={40}>

        {/* Refresh button wrapper — border color switches on focus */}
        <View
          ref={refreshButton}
          autofocus={true}
          height={84}
          width={304}
          borderRadius={18}
          style={{
            color: hexColor("#2d3748"),       // gray border (default)
            focus: { color: hexColor("#2563eb") },  // blue border (focused)
          }}
          onRight={() => { playListButton?.setFocus(); }}
          onEnter={() => {
            fetchPlaylistData();
            if (isLicenceExpired()) {
              setShouldPayScreenApperar(true);
            } else {
              setShouldPayScreenApperar(false);
            }
            playListButton?.setFocus();
          }}
        >
          {/* Inner card — always gray background, inset by 2px */}
          <View x={2} y={2} height={80} width={300} borderRadius={16} color={hexColor("#1e2330")}>
            <View style={{ flexDirection: "row", alignItems: "center" }}>
              <View x={25} y={26} width={28} height={28} src="https://i.ibb.co/xmPFS2y/refresh-page-option.png" />
              <Text fontSize={26} y={28} x={65} fontWeight="bold" style={{ fontFamily: fontFamily() }}>
                {t("refresh")}
              </Text>
            </View>
          </View>
        </View>

        {/* Playlist button wrapper */}
        <View
          ref={playListButton}
          x={340}
          height={84}
          width={304}
          borderRadius={18}
          style={{
            color: hexColor("#2d3748"),
            focus: { color: hexColor("#2563eb") },
          }}
          onLeft={() => { refreshButton?.setFocus(); }}
          onEnter={() => { setShouldPayScreenApperar(false); }}
        >
          <View x={2} y={2} height={80} width={300} borderRadius={16} color={hexColor("#1e2330")}>
            <View style={{ flexDirection: "row", alignItems: "center" }}>
              <View x={25} y={26} width={28} height={28} src="https://i.ibb.co/Wv8k0GR/list-1.png" />
              <Text fontSize={26} y={28} x={65} fontWeight="bold" style={{ fontFamily: fontFamily() }}>
                {t("playlist")}
              </Text>
            </View>
          </View>
        </View>

      </View>

    </View>
  );

  createEffect(() => {
    const savedPin = localStorage.getItem('userPin');
    const savedLocale = localStorage.getItem('app_locale');
    const savedTerms = localStorage.getItem('savedTerms');
    const savedSkip = localStorage.getItem('skiped');

    if (savedPin) {
      setStoredPin(savedPin);
      setPinExists(true);
    } else if (savedSkip) {
      setPinExists(true);
    }

    if (savedLocale) {
      setLanguageExist(true);
    }

    if (savedTerms) {
      setAcceptTerms(true)
    }
  });

  createEffect(() => {
    if (
      !loading() &&
      languageExists() &&
      acceptTerms() &&
      pinExists() &&
      !isUpdateModalOpen() &&
      !showKillSwitchBlockModal() &&
      !isDialogOpen() &&
      !isDialogOpenExit()
    ) {
      setTimeout(() => {
        const hasPlaylists = data().length > 0;

        if (!shouldPayScreenAppear() && hasPlaylists) {
          // Focus the Column — it will auto-focus its first child
          if (playlistColumnRef) {
            playlistColumnRef?.setFocus();
            setFocusedIndex(0);
          } else {
            safeFocusManager?.setFocus(refrshButton, null, "refresh fallback");
          }
        } else {
          safeFocusManager?.setFocus(refrshButton, null, "refresh (no playlists)");
        }
      }, 300);
    }
  });

  return (
    <View>
      <Show when={!languageExists()} fallback={
        <Show when={!acceptTerms()} fallback={
          <Show when={!pinExists()} fallback={

            <View
              // onEscape={() => {
              //   if (!shouldPayScreenAppear()) {
              //     setIsDialogOpenExit(true);
              //     cancelExit.setFocus();
              //   } else {
              //     setIsDialogOpenExit(true);
              //     cancelExit.setFocus();
              //     playListButton.setFocus();
              //   }
              // }}
              onEscape={() => {
                if (isUpdateModalOpen() || showKillSwitchBlockModal()) return; // guard modals
                setIsDialogOpenExit(true);
                setTimeout(() => {
                  cancelExit?.setFocus();
                }, 50);
              }}
              color={hexColor("#0d0f14")}
            >
              <Header screen={t("playlist")} />

              {/* ── Main content area ── */}
              <Show when={!shouldPayScreenAppear()} fallback={
                <View x={150} y={160} width={1600} height={760} borderRadius={20} color={hexColor("#15171b")}>
                  <FallbackView />
                </View>
              }>
                {/* ── Top-right buttons ── */}
                <View x={isRTL() ? 50 : 1700} y={50}>
                  <IconButton
                    onRef={(el) => { refrshButton = el; }}
                    x={0} y={0}
                    src="https://i.ibb.co/rRMjPDjY/refresh-2.png"
                    onRight={() => { searchButton?.setFocus(); }}
                    onDown={() => {
                      if (data().length === 0 || loading()) {
                        privacyButtonRef?.setFocus();
                      } else {
                        if (playlistColumnRef) {
                          playlistColumnRef?.setFocus();
                          setFocusedIndex(0);
                        }
                      }
                    }}
                    onEnter={() => { fetchPlaylistData(); }}
                    autofocus={data().length === 0 && !loading() && languageExists() && acceptTerms() && pinExists() && !isUpdateModalOpen() && !showKillSwitchBlockModal() && !isDialogOpen() && !isDialogOpenExit()}
                  />

                  <IconButton
                    onRef={(el) => { searchButton = el; }}
                    x={100} y={0}
                    src="https://i.ibb.co/Jjp8bmn4/setting.png"
                    onLeft={() => { refrshButton?.setFocus(); }}
                    onDown={() => {
                      if (data().length === 0 || loading()) {
                        privacyButtonRef?.setFocus();
                      } else {
                        if (playlistColumnRef) {
                          playlistColumnRef?.setFocus();
                          setFocusedIndex(0);
                        }
                      }
                    }}
                    onEnter={() => { navigate("/userInfo"); }}
                  />
                </View>

                <View x={150} y={160} width={1600} height={760} borderRadius={20} color={hexColor("#15171b")}>

                  {/* ── LEFT PANEL (QR side) — swaps to right in RTL ── */}
                  <View x={isRTL() ? 1150 : 75} y={80} width={600} height={740}>
                    <View x={35} width={300} height={290} borderRadius={16} color={hexColor("#ffffff")}>
                      <Show when={deviceInfoLoaded()}>
                        <View x={-37} y={-20} style={{ scale: 0.85 }}>
                          <QrCode deviceID={iDD()} api_token={tokenImage()} deviceYear={deviceYear()} />
                        </View>
                      </Show>
                    </View>

                    {/* "Manage Playlist" label */}
                    <Text x={105} y={310} style={{ fontSize: 23, color: hexColor("#8b949e"), fontWeight: isRTL() ? "normal" : "bold", fontFamily: fontFamily() }}>
                      {t("managePlaylist")}
                    </Text>

                    {/* Device ID card */}

                    <View x={0} y={350} width={380} height={88} borderRadius={14} color={hexColor("#2d3748")}>
                      <View x={2} y={2} width={376} height={84} borderRadius={12} color={hexColor("#0d1117")}>
                        <Text x={140} y={12} style={{ fontSize: 20, color: hexColor("#8b949e"), textAlign: "center", fontWeight: isRTL() ? "normal" : "bold", fontFamily: fontFamily() }} width={380}>
                          {t("deviceId")}
                        </Text>
                        <View x={40} y={40} style={{ flexDirection: "row", alignItems: "center" }}>
                          <View src="https://i.ibb.co/WNPhwwTN/Arrow-Forward.png" width={32} height={32} y={0} color={hexColor("#326dcf")} />
                          <Text x={38} y={4} style={{ fontSize: 24, color: hexColor("#326dcf"), fontWeight: isRTL() ? "normal" : "bold" }}>
                            {deviceId()}
                          </Text>
                        </View>
                      </View>
                    </View>

                    <AddPlaylistManuallyButton
                      onRef={(el: any) => { addPlaylistManuallyRef = el; }}
                      x={0} y={460}
                      onEnter={() => { navigate("/addPlaylist"); }}
                      onUp={() => { refrshButton?.setFocus(); }}
                      onDown={() => { privacyButtonRef?.setFocus(); }}
                      onRight={() => { if (!isRTL() && playlistColumnRef) playlistColumnRef.setFocus(); }}
                      onLeft={() => { if (isRTL() && playlistColumnRef) playlistColumnRef.setFocus(); }}
                    />

                    <Text x={0} y={560} style={{ fontSize: 20, color: hexColor("#8b949e") }} width={400} textAlign="center" fontWeight={isRTL() ? "normal" : "bold"} fontFamily={fontFamily()}>
                      {t("scanToAdd")}
                    </Text>
                    <Text x={0} y={590} style={{ fontSize: 20, color: hexColor("#326dcf") }} width={400} textAlign="center" fontWeight={isRTL() ? "normal" : "bold"} fontFamily={fontFamily()}>
                      https://orbixplay.com/mylist
                    </Text>
                  </View>

                  {/* ── VERTICAL DIVIDER ── */}
                  <View x={isRTL() ? 1048 : 550} y={120} width={2} height={500} color={hexColor("#2d3748")} />

                  {/* ── RIGHT PANEL (Playlists) — swaps to left in RTL ── */}
                  <View x={isRTL() ? 60 : 600} y={80} width={800} height={740}>
                    <Show when={loading()}>
                      <Text x={0} y={300} style={{ fontSize: 40, color: hexColor("#8b949e"), fontFamily: fontFamily() }}>
                        {t("loading")}
                      </Text>
                    </Show>

                    <Show when={!loading()}>
                      {/* Header */}
                      <Text x={0} y={0} style={{ fontSize: 48, color: hexColor("#f0f6fc"), fontWeight: isRTL() ? "normal" : "bold", fontFamily: fontFamily() }}>
                        {t('select_playlist')}
                      </Text>
                      <Text x={0} y={60} style={{ fontSize: 26, color: hexColor("#8b949e"), fontWeight: isRTL() ? "normal" : "bold", fontFamily: fontFamily() }}>
                        {t('choose_playlist')}
                      </Text>

                      <Show when={data().length === 0}>
                        <Text x={10} y={200} style={{ fontSize: 27, color: hexColor("#8b949e"), fontWeight: isRTL() ? "normal" : "bold", fontFamily: fontFamily() }}>
                          {t("noPlaylist")}
                        </Text>
                      </Show>

                      <Show when={data().length > 0}>
                        <View x={15} y={120} width={800} height={580}>
                          <Column
                            ref={el => { playlistColumnRef = el; }}
                            onUp={onUp}
                            onDown={onDown}
                            gap={16}
                          >
                            <For each={data().slice(currentIndex(), currentIndex() + ITEMS_PER_PAGE)}>
                              {(playlist: any, i) => {
                                const absoluteIndex = () => i() + currentIndex();

                                const getStatusForIndex = () => {
                                  const status = playlistStatus();
                                  return status ? status[absoluteIndex()] : undefined;
                                };

                                const getFailedForIndex = () => {
                                  const failed = playlistFailed();
                                  return failed ? failed[absoluteIndex()] : false;
                                };

                                const getExpiry = () => {
                                  const dates = playlistExpirationDates();
                                  return dates?.[absoluteIndex()] ?? null;
                                };

                                // true when line responded and expDate is in the past
                                const isExpired = () => {
                                  const expiry = getExpiry();
                                  return !getFailedForIndex() && isExpiredTimestamp(expiry);
                                };

                                return (
                                  <View
                                    width={892} height={120}
                                    borderRadius={20}
                                    color={hexColor("#0d1117")}
                                    style={{ focus: { borderWidth: 3, borderColor: hexColor("#2563eb") } }}
                                    onFocus={() => setFocusedIndex(i())}
                                    onEnter={() => {
                                      if (deleteJustPressed()) {
                                        setDeleteJustPressed(false);
                                        return;
                                      }
                                      changeIndex(absoluteIndex());
                                    }}
                                    onRight={() => {
                                      const btn = deleteButtonRefs[absoluteIndex()];
                                      if (btn) btn.setFocus();
                                    }}
                                    onLeft={() => { addPlaylistManuallyRef?.setFocus(); }}
                                    onUp={() => {
                                      if (i() === 0) onUp();
                                    }}
                                    onDown={() => {
                                      if (i() === Math.min(ITEMS_PER_PAGE, data().length) - 1) onDown();
                                    }}
                                  >
                                    {/* Focus indicator bar */}
                                    <Show when={i() === focusedIndex()}>
                                      <View x={0} y={8} width={8} height={100} borderRadius={20} color={hexColor("#2563eb")} />
                                    </Show>

                                    {/* Status dot */}
                                    <View x={30} y={33} width={55} height={55} borderRadius={10} color={hexColor("#1f2937")}>
                                      {(() => {
                                        const status = getStatusForIndex();
                                        if (status === undefined) {
                                          // Still loading — grey dot
                                          return <View x={17} y={17} width={20} height={20} borderRadius={10} color={hexColor("#808080")} />;
                                        }
                                        return <View x={17} y={17} width={20} height={20} borderRadius={10} color={hexColor(status ? "#22c55e" : "#ef4444")} />;
                                      })()}
                                    </View>

                                    {/* Playlist name */}
                                    <Text x={120} y={22} style={{ fontSize: 28, color: hexColor("#f0f6fc"), fontWeight: isRTL() ? "normal" : "bold" }}>
                                      {playlist.playlistName}
                                    </Text>

                                    {(() => {
                                      const status = getStatusForIndex();

                                      // 1. Loading
                                      if (status === undefined) return null;

                                      // 2. Error info (Bad status / Response code)
                                      const errorInfo = playlistErrorInfo()[absoluteIndex()];
                                      if (errorInfo) {
                                        return (
                                          <Text x={120} y={68} style={{ fontSize: 22, color: hexColor("#ef4444"), fontWeight: isRTL() ? "normal" : "bold" }}>
                                            {errorInfo}
                                          </Text>
                                        );
                                      }

                                      // 3. Failed line with no specific error info
                                      if (getFailedForIndex()) {
                                        return (
                                          <Text x={120} y={68} style={{ fontSize: 22, color: hexColor("#ef4444"), fontWeight: isRTL() ? "normal" : "bold" }}>
                                            Invalid line
                                          </Text>
                                        );
                                      }

                                      // 4. Line responded — show expiry date
                                      const expiry = getExpiry();
                                      const expired = isExpired();
                                      const formattedDate = expiry
                                        ? new Date(parseInt(expiry) * 1000).toLocaleDateString("en-GB")
                                        : "Unknown";

                                      return (
                                        <View x={120} y={65} style={{ flexDirection: "row", alignItems: "center" }}>
                                          <Text style={{ fontSize: 22, color: hexColor("#8b949e") }}>
                                            Expire Date: {formattedDate}
                                          </Text>
                                          <Show when={expired}>
                                            <Text x={250} style={{ fontSize: 20, color: hexColor("#ef4444"), fontWeight: isRTL() ? "normal" : "bold" }}>
                                              {" "}(Expired)
                                            </Text>
                                          </Show>
                                        </View>
                                      );
                                    })()}

                                    <DeleteButton
                                      ref={(el) => { deleteButtonRefs[absoluteIndex()] = el; }}
                                      x={820} y={32}
                                      onLeft={() => {
                                        const item = playlistColumnRef?.children?.[i()];
                                        if (item) item.setFocus();
                                        else playlistColumnRef?.setFocus();
                                      }}
                                      onEnter={() => {
                                        setDeleteJustPressed(true);
                                        setDeleteButtonIndex(absoluteIndex(), playlist);
                                      }}
                                    />
                                  </View>
                                );
                              }}
                            </For>
                          </Column>
                          <View ref={el => { deleteColumnRef = el; }} x={9999} onLeft={onLeft} />
                        </View>
                      </Show>
                    </Show>
                  </View>
                </View>

                {/* ── BOTTOM BAR ── */}
                <View x={60} y={980} width={1800} height={60}>
                  {/* Date + time */}
                  <View x={0} y={0}>
                    <Text style={{ fontSize: 30, color: hexColor("#f0f6fc"), fontWeight: isRTL() ? "normal" : "bold", fontFamily: fontFamily() }}>
                      {day()}
                    </Text>
                    <Text x={0} y={36} style={{ fontSize: 22, color: hexColor("#8b949e") }}>
                      {dateTime()}
                    </Text>
                  </View>

                  {/* Version */}
                  <Text x={700} y={18} style={{ fontSize: 24, color: hexColor("#8b949e"), fontFamily: fontFamily() }}>
                    {t("version")} {packageJson.version} • T:{tizenVersion()}
                  </Text>

                  {/* Privacy Mode button */}
                  <PrivacyModeButton
                    x={1430} y={-10}
                    onRef={el => { privacyButtonRef = el; }}
                    onEnter={() => { togglePrivacyMode(); fetchPlaylistData(); }}
                    onUp={() => {
                      if (data().length === 0) {
                        refrshButton?.setFocus();
                      } else {
                        playlistColumnRef?.setFocus();
                      }
                    }}
                  />
                </View>
              </Show>

              <Show when={showToast()}>
                <View
                  x={700} y={930}
                  width={500} height={70}
                  borderRadius={35}
                  color={hexColor("#2b324567")}
                  style={{ zIndex: 3000 }}
                >
                  {/* Message */}
                  <Text
                    x={120} y={25}
                    style={{
                      fontSize: 24,
                      color: hexColor("#f0f6fc"),
                      fontFamily: fontFamily(),
                    }}
                  >
                    {toastMessage()}
                  </Text>
                </View>
              </Show>

              {/* ── MODALS (unchanged) ── */}
              <Show when={showKillSwitchBlockModal()}>
                <View width={1920} height={1080} color={hexColor("#000000")} alpha={0.8} positionAbsolute={0} style={{ zIndex: 1999 }} />
                <View width={1920} height={1080} positionAbsolute={0} style={{ zIndex: 2000 }}>
                  <View x={460} y={240} width={1000} height={500} color={hexColor("#ffffff")} borderRadius={25}>
                    <View x={50} y={40}>
                      <Text x={0} y={10} style={{ fontSize: 32, color: hexColor("#000000"), fontWeight: isRTL() ? "normal" : "bold" }}>🛡️ Access Restricted</Text>
                    </View>
                    <View x={50} y={120}>
                      <Text x={0} y={0} style={{ fontSize: 28, color: hexColor("#ff4444"), fontWeight: isRTL() ? "normal" : "bold" }}>{t("kSwitchProtecionActive")}</Text>
                      <View x={0} y={60}>
                        <Text x={0} y={0} style={{ fontSize: 24, color: hexColor("#000000") }}>{t("enablePMode")}</Text>
                        <Text x={0} y={50} style={{ fontSize: 20, color: hexColor("#666666") }}>{t("killSwitchProtecting")}</Text>
                      </View>
                      <View x={0} y={150}>
                        <Text x={0} y={0} style={{ fontSize: 22, color: hexColor("#326dcf"), fontWeight: isRTL() ? "normal" : "bold" }}>To access playlists:</Text>
                        <Text x={0} y={40} style={{ fontSize: 20, color: hexColor("#000000") }}>1. Enable Privacy Mode from the main screen</Text>
                        <Text x={0} y={70} style={{ fontSize: 20, color: hexColor("#000000") }}>2. Or disable Kill Switch in Settings → Kill Switch</Text>
                      </View>
                    </View>
                    <View ref={(el) => { killSwitchBlockModalOkRef = el; }} x={425} y={380}
                      style={{ borderRadius: 20, color: hexColor("#326dcf"), focus: { color: hexColor("#0f6bb3"), scale: 1.05 }, transition: { scale: { duration: 250, easing: "ease-in-out" } }, height: 60, width: 150 }}
                      onEnter={() => { setShowKillSwitchBlockModal(false); playlistColumnRef?.setFocus(); }}
                    >
                      <Text x={65} y={20} style={{ fontSize: 24, color: hexColor("#ffffff"), fontWeight: isRTL() ? "normal" : "bold" }}>{t("ok")}</Text>
                    </View>
                  </View>
                </View>
              </Show>


              <Show when={isDialogOpen()}>
                <View x={500} y={350} width={800} height={300} color={hexColor("#ffffff")} borderRadius={20}>
                  <Text x={50} y={30} style={{ fontSize: 24, color: hexColor("#000000"), fontWeight: isRTL() ? "normal" : "bold", fontFamily: fontFamily() }}>{t("removePlaylist")}</Text>
                  <Text x={50} y={100} style={{ fontSize: 24, color: hexColor("#000000"), fontFamily: fontFamily() }}>{t("wantToRemove")}</Text>
                  <View ref={el => { cancelButtonRef = el; }} x={430} y={220}
                    style={{ borderRadius: 15, color: hexColor("#C1C3C1"), focus: { color: hexColor("#326dcf") }, transition: { scale: { duration: 250, easing: "ease-in-out" } }, height: 45, width: 150 }}
                    onEnter={() => { setIsDialogOpen(false); if (data().length > 0 && !loading()) { safeFocusManager?.setFocus(playlistColumnRef, refrshButton, "playlist column after cancel"); } else { safeFocusManager?.setFocus(refrshButton, refreshRef, "refresh button after cancel"); } }}
                    onRight={() => okButtonRefrefreshRef?.setFocus()}
                  >
                    <Text x={40} y={15} style={{ fontSize: 18, color: hexColor("#000000"), fontFamily: fontFamily() }}>{t("cancelBig")}</Text>
                  </View>
                  <View ref={el => { okButtonRefrefreshRef = el; }} x={600} y={220}
                    style={{ borderRadius: 15, color: hexColor("#C1C3C1"), focus: { color: hexColor("#326dcf") }, transition: { scale: { duration: 250, easing: "ease-in-out" } }, height: 45, width: 150 }}
                    onLeft={() => cancelButtonRef?.setFocus()}
                    onEnter={() => { handleDelete(playlist()); setIsDialogOpen(false); setTimeout(() => { if (data().length > 0 && !loading()) { safeFocusManager?.setFocus(playlistColumnRef, refrshButton, "playlist column after delete"); } else { safeFocusManager?.setFocus(refrshButton, refreshRef, "refresh button after delete"); } }, 100); }}
                  >
                    <Text x={60} y={15} style={{ fontSize: 18, color: hexColor("#000000"), fontFamily: fontFamily() }}>{t("ok")}</Text>
                  </View>
                </View>
              </Show>

              <Show when={isDialogOpenExit()}>
                <View x={500} y={350} width={800} height={300} color={hexColor("#ffffff")} borderRadius={20}>
                  <Text x={50} y={30} style={{ fontSize: 24, color: hexColor("#000000"), fontWeight: isRTL() ? "normal" : "bold", fontFamily: fontFamily() }}>{t("exitApp")}</Text>
                  <Text x={50} y={100} style={{ fontSize: 24, color: hexColor("#000000"), fontFamily: fontFamily() }}>{t("wantToExit")}</Text>
                  <View ref={el => { cancelExit = el; }} x={430} y={220}
                    style={{ borderRadius: 15, color: hexColor("#C1C3C1"), focus: { color: hexColor("#326dcf") }, transition: { scale: { duration: 250, easing: "ease-in-out" } }, height: 45, width: 150 }}
                    onEnter={() => {
                      setIsDialogOpenExit(false);
                      // Smart focus restoration based on current screen state
                      if (!shouldPayScreenAppear()) {
                        // Normal screen - check for playlists
                        if (data().length > 0 && !loading()) {
                          playlistColumnRef?.setFocus();
                        } else {
                          refrshButton?.setFocus();
                        }
                      } else {
                        // Pay screen - focus on playlist button
                        playListButton?.setFocus();
                      }
                    }}
                    onRight={() => okExit?.setFocus()}
                  >
                    <Text x={40} y={15} style={{ fontSize: 18, color: hexColor("#000000"), fontFamily: fontFamily() }}>{t("cancelBig")}</Text>
                  </View>
                  <View ref={el => { okExit = el; }} x={600} y={220}
                    style={{ borderRadius: 15, color: hexColor("#C1C3C1"), focus: { color: hexColor("#326dcf") }, transition: { scale: { duration: 250, easing: "ease-in-out" } }, height: 45, width: 150 }}
                    onLeft={() => cancelExit?.setFocus()}
                    onEnter={() => { window.close() }}
                  >
                    <Text x={60} y={15} style={{ fontSize: 18, color: hexColor("#000000"), fontFamily: fontFamily() }}>{t("ok")}</Text>
                  </View>
                </View>
              </Show>

            </View>
          }>
            <Show when={acceptTerms()} fallback={<></>}>
              <SetPin
                onPinSet={(pin) => {
                  setStoredPin(pin); setPinExists(true);
                  // If the global "what's new" modal is open, it already owns focus
                  // itself; otherwise the reactive focus-management effect above picks
                  // this up once pinExists() flips true.
                  setTimeout(() => {
                    if (!isUpdateModalOpen()) {
                      if (data().length > 0) {
                        playlistColumnRef?.setFocus();
                      } else {
                        refrshButton?.setFocus();
                      }
                    }
                  }, 1000);
                }}
                autoFocus={true}
                onSkip={() => { setPinExists(true); localStorage.setItem('skiped', 'true'); }}
                inputDelay={200}
              />
            </Show>
          </Show>
        }>
          <Termsconditions onPinSet={() => { }} onAcceptTerms={() => { setAcceptTerms(true); localStorage.setItem('savedTerms', 'true'); }} />
        </Show>
      }>
        <SetLanguage onPinSet={() => { localStorage.setItem('app_locale', locale()); setLanguageExist(true) }} />
      </Show>
    </View>
  );
};
export default LicenceScreen;